module.exports = __webpack_public_path__ + "static/media/texture-wood-light-brown.ff0800d3.jpg";